<template>
  <div>
    <chart
      :datas="chartDatas"
      :mapIsclick="mapIsclick"
      @callBack="mapClick"
    ></chart>
    <div class="city-title">城市使用数据</div>
    <van-dropdown-menu class="van-hairline--top-bottom" active-color="#2f80ed">
      <van-dropdown-item
        :title="province == 'ALL' ? '全国' : province"
        class="left"
        v-model="province"
        :options="provinceOption"
        @change="
          _resetPage()
          getProvinceList()
        "
      />
      <van-dropdown-item title="数据指标" ref="dataFilter">
        <TableFilter
          :columnData="columnData"
          @ok="ok"
          @getFilter="getFilter"
        ></TableFilter>
      </van-dropdown-item>
      <van-dropdown-item
        class="right"
        v-model="sort"
        :title="sortText"
        :options="sortList"
      />
    </van-dropdown-menu>
    <!-- <div class="tag flex-center">
      <van-tag
        @click="
          currentTag = index
          page = 0
          finished = false
          start = ''
          end = ''
          getMapData()
          getProvinceList()
        "
        :color="currentTag == index ? '#2F80ED' : ''"
        round
        v-for="(item, index) in timeTag"
        :plain="currentTag !== index"
        :id="index"
        :key="index"
        >{{ item.title }}</van-tag
      >
    </div>
    <div class="time-range van-hairline--top flex-center">
      <div @click="selectTime('start')">
        <span :style="{ color: start ? '#000' : '#C8C9CC' }">{{
          start ? moment(+start).format('YYYY-MM-DD') : '选择开始时间'
        }}</span>
      </div>
      <img
        src="https://img.esenyun.com/images/20200702/71fd65cc43484f26b21f887ec3c10607.png"
        style="width: 12px;height:12px;margin-left: 4px;"
      />
      <div style="font-size: 13px;color:#969799;margin:0 16px;">至</div>
      <div @click="selectTime('end')">
        <span :style="{ color: end ? '#000' : '#C8C9CC' }">{{
          end ? moment(+end).format('YYYY-MM-DD') : '选择结束时间'
        }}</span>
      </div>
      <img
        src="https://img.esenyun.com/images/20200702/71fd65cc43484f26b21f887ec3c10607.png"
        style="width: 12px;height:12px;margin-left: 4px;"
      />
    </div> -->
    <div
      class="time-area van-hairline--top"
      @click="showTimeArea = true"
      v-if="start"
    >
      <div class="flex-center" style="padding-left: 23px;height: 100%;">
        <img
          src="https://img.esenyun.com/images/20200824/71fc8c146a5e49788b869b5058ee0d02.png"
          style="width: 16px;height: 16px;margin-right: 6px;"
        />
        {{ currentTag !== -1 ? timeTag[currentTag].title : '' }} ({{
          moment(start).format('YYYY-MM-DD')
        }}
        - {{ moment(end).format('YYYY-MM-DD') }})
        <img
          src="https://img.esenyun.com/images/20200702/71fd65cc43484f26b21f887ec3c10607.png"
          style="width: 12px;height:12px;margin-left: 4px;"
        />
      </div>
    </div>
    <van-list :finished="finished" finished-text="1" @load="getProvinceList">
      <Table
        :columnData="columnData"
        :dataSource="dataSource"
        :finished="finished"
      ></Table>
      <div style="height: 50px;text-align:center;color:#c8c9cc;font-size:10px;">
        ------ 这里是底线 ------
      </div>
    </van-list>
    <!-- 排序 -->
    <div class="sort-area" @click="reserveSort">
      <div class="flex-center" style="justify-content:center;height: 100%;">
        <img
          :src="
            currentSortVal.indexOf('desc') === -1
              ? 'https://img.esenyun.com/images/20200824/807b22d7fcf24e4a8b0dd1e80e3fd50d.png'
              : 'https://img.esenyun.com/images/20200824/eb4c510796c845cba6283280fce8bcb1.png'
          "
          style="width:16px;height: 16px;margin-right:8px;"
        />
        {{ sortText
        }}{{ currentSortVal.indexOf('desc') === -1 ? '升序' : '降序' }}
      </div>
    </div>
    <van-popup
      v-model="showTimeArea"
      position="bottom"
      close-on-click-overlay
      @close="showTimeArea = false"
    >
      <div style="height: 16px;"></div>
      <div class="tag-list flex-center">
        <div
          class="tag"
          :class="{ 'tag-active': currentTag === index }"
          v-for="(item, index) in timeTag"
          :key="item.title"
          @click="changeTime(index)"
        >
          {{ item.title }}
        </div>
      </div>
      <div
        style="font-weight: 500;font-size: 14px;line-height: 22px;padding:0 16px 16px 16px;"
      >
        自定义
      </div>
      <div class="time-range flex-center">
        <div
          class="tag"
          style="margin: 0;width: 183px;"
          @click="selectTime('start')"
        >
          <span :style="{ color: start ? '#000' : '#C8C9CC' }">{{
            start ? moment(start).format('YYYY-MM-DD') : '选择开始时间'
          }}</span>
        </div>

        <div
          style="font-size: 13px;line-height: 22px;color: #323233;margin:0 16px;"
        >
          至
        </div>
        <div
          class="tag"
          style="margin: 0;width: 183px;"
          @click="selectTime('end')"
        >
          <span :style="{ color: end ? '#000' : '#C8C9CC' }">{{
            end ? moment(end).format('YYYY-MM-DD') : '选择结束时间'
          }}</span>
        </div>
      </div>
      <div
        class="flex-center"
        style="justify-content:space-between;margin-top:36px;padding: 0 16px;"
      >
        <van-button
          style="width:159px;border-radius: 5px;"
          plain
          color="#2F80ED"
          @click="resetTime"
          >重置</van-button
        >
        <van-button
          style="width:159px;border-radius: 5px;"
          color="#2F80ED"
          @click="showTimeArea = false"
          >确定</van-button
        >
      </div>
      <div style="height: 24px;"></div>
    </van-popup>
    <van-popup v-model="showTime" position="bottom">
      <van-datetime-picker
        type="date"
        v-model="currentDate"
        :max-date="maxDate"
        :min-date="minDate"
        @confirm="sureTime"
        @cancel="showTime = false"
        :formatter="formatter"
      />
    </van-popup>
  </div>
</template>
<script>
import TableFilter from '../components/data/TableFilter'
import chart from '../components/eChart/chart'
import Table from '../components/data/TableV2'
import map from '../components/eChart/name'
import list from '../mixins/list'
import moment from 'moment'
export default {
  components: {
    chart,
    TableFilter,
    Table,
  },
  mixins: [list],
  watch: {
    sort: function(val) {
      this.currentSortVal = val
      this.sortList.forEach((item) => {
        if (item.value === this.currentSortVal) {
          this.sortText = item.text
        }
      })
      this._resetPage()
      this.getMapData()
      this.getProvinceList()
    },
  },
  data() {
    return {
      currentTag: 0,
      showTimeArea: false,
      showTime: false,
      currentDate: new Date(),
      maxDate: new Date(),
      minDate: new Date(['2020/08/17']),
      currentSelect: 'start',
      start: new Date(),
      end: new Date(),
      formatter(type, value) {
        if (type === 'year') {
          return `${value}年`
        } else if (type === 'month') {
          return `${value}月`
        } else {
          return `${value}日`
        }
        // return value
      },
      sort: 'enter_yesterday,desc',
      currentSortVal: 'enter_yesterday,desc',
      sortText: '潜客排序',
      sortList: [
        { text: '潜客排序', value: 'enter_yesterday,desc' },
        { text: '活跃率排序', value: 'active_rate,desc' },
        { text: '活跃人数排序', value: 'active,desc' },
        { text: '累计活跃人数排序', value: 'active_all,desc' },
        { text: '累计潜客排序', value: 'enter_all,desc' },
      ],
      province: 'ALL',
      provinceOption: [{ text: '全国', value: 'ALL' }],
      moment: moment,
      token: '',
      timeTag: [
        {
          title: '昨天',
          start:
            moment()
              .subtract(1, 'days')
              .format('YYYY-MM-DD') + ' 00:00:00',
          end:
            moment()
              .subtract(1, 'days')
              .format('YYYY-MM-DD') + ' 23:59:59',
        },
        {
          title: '近7天',
          start:
            moment()
              .subtract(7, 'days')
              .format('YYYY-MM-DD') + ' 00:00:00',
          end:
            moment()
              .subtract(1, 'days')
              .format('YYYY-MM-DD') + ' 23:59:59',
        },
        {
          title: '近30天',
          start:
            moment()
              .subtract(30, 'days')
              .format('YYYY-MM-DD') + ' 00:00:00',
          end:
            moment()
              .subtract(1, 'days')
              .format('YYYY-MM-DD') + ' 23:59:59',
        },
      ],
      dataSource: [],
      columnData: [
        {
          title: '省区名称',
          width: 91,
          active: true,
          key: 'parentOrgName',
        },
        {
          title: '潜客数量',
          width: 86,
          active: true,
          key: 'yesterdayEnter',
          format: '（人）',
          subtitle: true,
          introduce: '在所选时间范围内带来的已报名潜客数量之和',
        },
        {
          title: '活跃率',
          width: 86,
          active: true,
          key: 'activeRate',
          introduce:
            '在所选时间范围内的直销员活跃率（活跃直销员/直销员总数*100%）',
        },
        {
          title: '活跃人数',
          width: 86,
          active: true,
          subtitle: true,
          key: 'yesterdayActive',
          format: '（人）',
          introduce: '在所选时间范围内的直销员活跃人数',
        },
        {
          title: '大使数量',
          width: 86,
          active: true,
          key: 'yesterdayAmbassador',
          format: '（人）',
          subtitle: true,
          introduce: '在所选时间范围内带来的大使数量之和',
        },
        {
          title: '转发数量',
          width: 86,
          active: false,
          key: 'yesterdayForward',
          format: '（次）',
          subtitle: true,
          introduce: '在所选时间范围内带来的转发数量之和',
        },
        {
          title: '任务',
          alias: '任务完成率',
          width: 86,
          active: false,
          key: 'yesterdayTaskCompletionRate',
          format: '完成率',
          introduce:
            '在所选时间范围内任务中心总任务完成率（已完成的任务/全部任务*100%）',
        },
      ],
      chartDatas: {
        backgroundColor: '#FFFFFF',
        tooltip: {
          trigger: 'item',
          // formatter: '活跃度<br/>{b0}: {c0}%',
          formatter: (params) => {
            return `活跃度<br/>${params.name}: ${
              params.data ? params.data.value : 0
            }%`
          },
        },
        dataRange: {
          x: '10px',
          y: 'bottom',
          splitList: [
            { start: 90, label: '90%+' },
            { start: 60, end: 89, label: '60%～89%' },
            { start: 30, end: 59, label: '30%～59%' },
            { start: 1, end: 29, label: '1%～29%' },
            { end: 0, label: '0%' },
          ],
          color: ['#1E61C7', '#5AA5FA', '#ADD9FF', '#F0F9FF'],
        },
        geo: {
          map: 'china',
          zoom: 1.1,
          label: {
            emphasis: {
              show: false, // 城市模式下，鼠标移上去不显示省份名称
            },
          },
          itemStyle: {
            normal: {
              color: 'black',
              areaColor: '#e0effb',
              borderColor: '#72ABC5',
              fontSize: '10px',
            },
            emphasis: {
              areaColor: '#e0effb',
            },
          },
        },
        // 配置属性
        series: [
          {
            name: '活跃度数据',
            type: 'map',
            mapType: 'china',
            coordinateSystem: 'geo',
            symbolSize: 5,
            zoom: 1.1,
            label: {
              show: true,
              fontSize: '45%',
              fontWeight: '600',
              color: '#000000',
            },
            itemStyle: {
              normal: {
                areaColor: '#ffffff',
                borderColor: '#2481c9',
                shadowBlur: 0,
                shadowColor: '',
              },
              emphasis: {
                areaColor: '#F9E14C',
              },
            },
            data: [], // 数据
            // nameMap: map.province
          },
        ],
      },
      mapIsclick: true,
    }
  },
  mounted() {
    document.title = '城市排行'
    this.token = this.$route.query.token
    this.start = moment()
      .subtract(1, 'days')
      .toDate()
    this.end = moment()
      .subtract(1, 'days')
      .toDate()
    this.getProvinceList()
    this.getAllCity()
    this.getMapData()
  },
  methods: {
    reserveSort() {
      window.scrollTo(0, 0)
      if (this.currentSortVal.indexOf('desc') !== -1) {
        this.sort = this.currentSortVal.replace(',desc', '')
      } else {
        this.sort = this.currentSortVal + ',desc'
      }
      this.currentSortVal = this.sort
      this._resetPage()
      this.getAllCity()
      this.getMapData()
    },
    selectTime(name) {
      this.showTime = true
      if (this[name]) {
        this.currentDate = this[name]
      }
      this.currentSelect = name
    },
    sureTime(e) {
      this.currentTag = -1
      if (this.currentSelect === 'end') {
        if (this.moment(e) <= this.moment(this.start)) {
          return this.$Toast('结束时间必须大于开始时间')
        }
      }
      this.showTime = false
      this[this.currentSelect] = e
      // console.log(this.currentSelect)
      if (this.start && this.end) {
        this.page = 0
        this.finished = false
        this.getMapData()
        this.getProvinceList()
      }
    },
    changeTime(index) {
      this.currentTag = index
      console.log(index)
      if (this.currentTag !== -1) {
        this.start = this.moment(this.timeTag[index].start).toDate()
        this.end = this.moment(this.timeTag[index].end).toDate()
      }
      this._resetPage()
      this.getMapData()
      this.getProvinceList()
    },
    resetTime() {
      this.currentTag = 0
      this.start =
        moment()
          .subtract(1, 'days')
          .unix() + '000'
      this.end = moment().unix() + '000'
      this.showTimeArea = false
      this._resetPage()
      this.getMapData()
      this.getProvinceList()
    },
    ok() {
      this.$refs.dataFilter.toggle()
    },
    getFilter(item) {
      this.columnData = item
    },
    mapClick(data) {
      this._resetPage()
      this.province = map.province[data.name]
      this.getProvinceList()
    },
    getMapData() {
      let { start, end } = ['', '']
      console.log(this.start)
      if (this.start) {
        start = this.moment(this.start).format('YYYY-MM-DD 00:00:00')
      }
      if (this.end) {
        end = this.moment(this.end).format('YYYY-MM-DD 23:59:59')
      }
      this.$http
        .get(
          `aocampaignsales/openapi/data/allProvinceData/${encodeURIComponent(
            start
          )}/${encodeURIComponent(end)}`,
          {
            headers: {
              Authorization: `Bearer ${this.token}`,
            },
          }
        )
        .then((res) => {
          this.chartDatas.series[0].data = []
          res.data.forEach((data) => {
            this.chartDatas.series[0].data.push({
              name: map.provinceFormat[data.provinceName],
              value: data.activeRate,
            })
          })
          console.log(this.chartDatas.series[0].data)
        })
    },
    getAllCity() {
      this.$http
        .get(`aocampaignsales/openapi/common/geo/getCity`, {
          headers: {
            Authorization: `Bearer ${this.token}`,
          },
        })
        .then((res) => {
          this.provinceOption = [...this.provinceOption, ...res.data]
        })
        .catch(() => {
          this.getNewToken()
        })
    },
    getNewToken() {
      let refresh_token = this.$route.query.refresh_token
      this.$http
        .post(
          `esenuaa/oauth/token`,
          `grant_type=refresh_token&refresh_token=${refresh_token}`,
          {
            headers: {
              Authorization: 'Basic c29jaWFsX3d4X2FwcDpJdjc3ampHMTRNVjc=',
              'Content-Type': 'application/x-www-form-urlencoded',
            },
          }
        )
        .then((res) => {
          this.token = res.data.access_token
          this._resetPage()
          this.getMapData()
          this.getProvinceList()
          this.getAllCity()
        })
    },
    // 获取省下所有
    getProvinceList() {
      if (this.checkListStatus()) return
      const data = {
        page: this.page,
      }
      let { start, end } = ['', '']
      if (this.start) {
        start = this.moment(this.start).format('YYYY-MM-DD 00:00:00')
      }
      if (this.end) {
        end = this.moment(this.end).format('YYYY-MM-DD 23:59:59')
      }
      if (this.sort) {
        data.sort = this.sort
      }
      this.$http
        .get(
          `aocampaignsales/openapi/data/cityUseData/${encodeURIComponent(
            start
          )}/${encodeURIComponent(end)}/${this.province}${this.$share.qsUrl(
            data
          )}`,
          {
            headers: {
              Authorization: `Bearer ${this.token}`,
            },
          }
        )
        .then((res) => {
          res.data.content.forEach((item) => {
            item.activeRate = item.activeRate + '%'
            item.yesterdayTaskCompletionRate = item.yesterdayTaskCompletionRate
              ? item.yesterdayTaskCompletionRate + '%'
              : '0%'
            item.yesterdayActive = {
              title: this.$share.formatNum(item.yesterdayActive),
              subtitle: `总数${this.$share.formatNum(item.activeAll)}`,
            }
            item.yesterdayEnter = {
              title: this.$share.formatNum(item.yesterdayEnter),
              subtitle: `累计${this.$share.formatNum(item.enterAll)}`,
            }
            item.yesterdayAmbassador = {
              title: this.$share.formatNum(item.yesterdayAmbassador),
              subtitle: `累计${this.$share.formatNum(item.ambassadorAll)}`,
            }
            item.yesterdayForward = {
              title: this.$share.formatNum(item.yesterdayForward),
              subtitle: `累计${this.$share.formatNum(item.forwardAll)}`,
            }
            item.yesterdayActivityCount = {
              title: this.$share.formatNum(item.yesterdayActivityCount),
              subtitle: `累计${this.$share.formatNum(item.allActivityCount)}`,
            }
          })
          this.dealListPage({
            key: 'dataSource',
            list: res.data.content,
            total: res.data.totalElements,
          })
        })
    },
  },
}
</script>
<style lang="less" scoped>
.time-range {
  font-size: 16px;
  line-height: 22px;
  height: 48px;
  padding: 0 16px;
  background: #fff;
}
.tag-list {
  padding: 0 16px;
  justify-content: space-between;
  flex-wrap: wrap;
}
.tag {
  width: 102px;
  height: 32px;
  margin-bottom: 20px;
  color: #000;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 13px;
  background: #f7f8fa;
  border-radius: 64px;
}
.tag-active {
  border: 1px solid #2f80ed;
  color: #2f80ed;
  background: rgba(47, 128, 237, 0.1);
}
/deep/.van-dropdown-menu__bar {
  box-shadow: none;
}
.van-tag {
  padding: 2px 12px;
  margin-right: 16px;
}
/deep/.van-dropdown-menu {
  /deep/.van-dropdown-menu__item:nth-child(1) {
    justify-content: flex-start;
    padding-left: 16px;
  }
  /deep/.van-dropdown-menu__item:nth-child(2) {
    justify-content: flex-end;
    padding-right: 45px;
  }
  /deep/.van-dropdown-menu__item:nth-child(3) {
    justify-content: flex-end;
    padding-right: 16px;
  }
}
.city-title {
  height: 48px;
  padding-left: 16px;
  font-weight: 500;
  font-size: 14px;
  line-height: 48px;
  background: #fff;
}
.time-area {
  height: 48px;
  background: #fff;
  font-size: 14px;
}
.sort-area {
  width: 100%;
  bottom: 0;
  background: #fff;
  box-shadow: 0px -2px 4px rgba(121, 121, 121, 0.08);
  position: fixed;
  height: 49px;
  z-index: 3;
  font-size: 14px;
  line-height: 24px;
  color: #2f80ed;
}
</style>
